import $ from 'jquery'
import _ from 'lodash'
import selects from 'scoreboard/components/selects'

function renderSheetIndexSelect(el, sheets, sheetIndex) {
	el = $(el)
	let hasSheets = _.size(sheets) > 1
	el.find('.sheet-index').toggleClass('is-not-displayed', !hasSheets)
	if (hasSheets) {
		let options = _.map(sheets, (sheet, index) => {
			return {
				value: index,
				label: sheet
			}
		})
		let selected =
			_.isNil(sheetIndex) || sheetIndex == '' ? 0 : sheetIndex
		selects.filtering(el.find('[name=sheetIndex]'), {
			selected, // #52604
			options
		})
	}
}

export default renderSheetIndexSelect

renderSheetIndexSelect.__filename__ = 'imports/render-sheet-index-select.js'
